<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue'
import { useNavigationStore } from '@/stores/navigation'
import { useExplanationStore } from '@/stores/explanations'
import { useMessagesStore } from '@/stores/messages'
import ConversationWindow from '@/components/conversations/ConversationWindow.vue'
import ConversationsSidebar from '@/components/sidebars/ConversationsSidebar.vue'
import InsightsSidebar from '@/components/sidebars/InsightsSidebar.vue'

const navigationStore = useNavigationStore()
const explanationStore = useExplanationStore()
const messagesStore = useMessagesStore()

const LG_SCREEN_WIDTH = 1024
const isMobile = ref(window.innerWidth < LG_SCREEN_WIDTH) // Check if screen is small
const transitionName = ref('slide-left')

// Detect screen size changes
const updateScreenSize = () => {
  isMobile.value = window.innerWidth < LG_SCREEN_WIDTH
}

onMounted(() => window.addEventListener('resize', updateScreenSize))
onBeforeUnmount(() => window.removeEventListener('resize', updateScreenSize))

function isActiveSectionEqual (section) {
  return navigationStore.activeSection === section || !isMobile.value
}

watch(() => explanationStore.selectedMessage, (newValue) => {
  console.log('Selected message changed')
  if (newValue) {
    console.log('sliding rigt')
    transitionName.value = 'slide-right'
    setTimeout(() => {
      navigationStore.setActiveSection('insights')
    }, 100)
  }
})

watch(() => messagesStore.currentConversation, (newValue) => {
  console.log('Selected conversation changed')
  if (newValue) {
    console.log('sliding left')
    transitionName.value = 'slide-left'
    navigationStore.setActiveSection('conversation')
  } else {
    console.log('sliding left')
    transitionName.value = 'slide-left'
  }
})
</script>

<template>
  <div class="flex flex-1 bg-gray-100 transition-all duration-300 relative overflow-hidden">
    <!-- Conversations Sidebar -->
    <Transition name="slide-right">
      <ConversationsSidebar v-if="isActiveSectionEqual('sidebar')"
        class="absolute w-full lg:relative lg:w-3/12 bg-white h-full" />
    </Transition>

    <!-- Conversation Window -->
    <Transition :name="transitionName">
      <ConversationWindow v-if="isActiveSectionEqual('conversation')"
        class="absolute w-full lg:relative lg:w-9/12 bg-white h-full" />
    </Transition>

    <!-- Insights Sidebar -->
    <Transition name="slide-left">
      <InsightsSidebar v-if="isActiveSectionEqual('insights') && explanationStore.selectedMessage"
        class="absolute w-full lg:relative lg:w-3/12 bg-white h-full" @close-sidebar="navigationStore.setActiveSection('conversation')" />
    </Transition>
  </div>
</template>

<style scoped>
/* Forward animation (sidebar → conversation → insights) */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

.slide-left-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-left-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* Backward animation (insights → conversation → sidebar) */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

.slide-right-enter-from {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-right-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
</style>
